// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import numeral from 'numeral';

import CurrencyIcon from 'app/components/commons/CurrencyIcon';
import Button from 'app/components/commons/Button';
import Loader from 'app/components/commons/Loader';
import Columns from 'app/components/commons/Columns';

type Props = {
  disabled: boolean,
  isLoading: boolean,
  qty: number,
  onSelectTeam: () => void,
  totalFee: number
};

const Bold = styled.span(({ theme }) => ({
  fontWeight: theme.fontWeight.demiBold,
  color: theme.color.primary
}));

const Footer = styled.div(({ theme }) => ({
  backgroundColor: theme.color.basis6,
  textTransform: 'uppercase',
  color: theme.color.basis1,
  padding: theme.spacing.small,
  marginTop: theme.spacing.small
}));

const FooterSection: React.FC<Props> = ({
  disabled,
  isLoading,
  qty,
  onSelectTeam,
  totalFee
}: Props) => (
  <Footer>
    <Columns className="is-vcentered">
      <div className="column is-half">
        <Columns className="is-vcentered">
          <div className="column">
            contests selected: <Bold>{qty}</Bold>
          </div>
          <div className="column">
            total buy-in:{' '}
            <Bold>
              <CurrencyIcon />
              {numeral(totalFee).format('0,0.[00]')}
            </Bold>
          </div>
        </Columns>
      </div>
      <div className="column is-half">
        <Button kind="success" style={{ width: '100%' }} onClick={onSelectTeam} disabled={disabled}>
          {isLoading ? <Loader /> : <span>Select Team</span>}
        </Button>
      </div>
    </Columns>
  </Footer>
);

export default FooterSection;
